import styled from 'styled-components';

export const SummaryItemWrapper = styled.div`
  padding: 10px;
  background-color: ${({ theme }) => theme.white.a10};
  display: flex;
  justify-content: flex-start;
  border-top: 1px solid ${({ theme }) => theme.black.a1};
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.03);
  font-size: 15px;
  letter-spacing: 0.3px;
  text-align: left;
  color: ${({ theme }) => theme.baseBlue.a10};
  align-items: center;
`;

export const QuestionTitle = styled.span`
  color: ${({ theme }) => theme.baseBlue.a6};
  margin-left: 10px;
`;

export const DraggableIcon = styled.div`
  width: 18px;
  height: 14px;
  color: ${({ theme }) => theme.baseBlue.a6};
  cursor: move;
`;

export const SummaryQuestionHeader = styled.div`
  background-color: ${({ theme }) => theme.white.a10};
  border-radius: 5px 0;
  display: flex;
  justify-content: space-between;
  padding: 15px 30px;
  color: ${({ theme }) => theme.baseBlue.a10};
`;

export const SummaryPre = styled.div`
  margin: 30px 0;
  text-align: center;
  font-weight: 600;
  color: ${({ theme }) => theme.baseBlue.a6};
`;

export const SummarySelectContainer = styled.div`
  margin-top: 30px;
  margin-bottom: 60px;
`;

export const SummaryTitle = styled.div`
  font-size: 21px;
  display: flex;
  align-items: center;
  > span {
    margin-right: 5px;
  }
`;

export const SummaryButton = styled.span`
  line-height: 1.467rem;
  letter-spacing: 0.3px;
  white-space: nowrap;
  font-weight: 600;
  text-transform: uppercase;
  color: ${({ theme }) => theme.baseBlue.a10};
  opacity: 0.65;
  font-size: 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  > span {
    margin-left: 5px;
  }
`;
